<script lang="ts">
  import Logo from './Logo.svelte'

  const COLUMNS = [
    {
      title: 'Product',
      links: [
        { href: '/features', label: 'Features' },
        { href: '/protocols', label: 'Protocols' },
        { href: '/backends', label: 'Backends' },
        { href: '/compatibility', label: 'Compatibility ledger' },
        { href: '/pricing', label: 'Pricing' },
        { href: '/download', label: 'Download' },
        { href: '/macfuse', label: 'macFUSE on macOS' },
        { href: '/compare', label: 'Compare alternatives' },
      ],
    },
    {
      title: 'Help',
      links: [
        { href: '/docs', label: 'Documentation' },
        { href: '/docs/first-mount', label: 'Mounting a volume' },
        { href: '/support', label: 'Contact support' },
        { href: '/changelog', label: 'Changelog' },
        { href: '/news', label: 'News' },
        { href: '/account', label: 'Accounts — coming soon' },
      ],
    },
    {
      // French law requires the French set. OAuth verification requires the
      // privacy policy to be reachable from the HOME PAGE at a stable URL on
      // this domain — a reviewer looks for the link, not just the URL, and a
      // missing one is a routine cause of rejection. That is why these are in
      // the footer rather than only in the sitemap.
      title: 'Légal',
      links: [
        { href: '/legal/mentions-legales', label: 'Mentions légales' },
        { href: '/legal/confidentialite', label: 'Confidentialité' },
        { href: '/legal/cgu', label: 'CGU' },
        { href: '/legal/cgv', label: 'CGV' },
        { href: '/legal/cookies', label: 'Cookies' },
        { href: '/legal/licence', label: 'Licence' },
        { href: '/legal/sous-traitance', label: 'Sous-traitance' },
      ],
    },
    {
      title: 'Legal (EN)',
      links: [
        { href: '/legal/privacy', label: 'Privacy policy' },
        { href: '/legal/terms', label: 'Terms of use' },
        { href: '/legal/license', label: 'Licence agreement' },
        { href: '/security', label: 'Security' },
        { href: '/exit', label: 'Leaving Mountit' },
      ],
    },
  ]

  const year = new Date().getFullYear()
</script>

<footer class="footer">
  <div class="page page--wide">
    <div class="footer__grid">
      <div class="footer__brand">
        <Logo size={26} />
        <p class="footer__blurb">
          Remote storage, mounted as a drive in Finder on Apple platforms.
          A Rust core, a SwiftUI app, and no kernel extensions.
        </p>
      </div>

      {#each COLUMNS as column (column.title)}
        <nav class="footer__col" aria-label={column.title}>
          <h2 class="footer__title">{column.title}</h2>
          <ul>
            {#each column.links as link (link.href)}
              <li><a href={link.href}>{link.label}</a></li>
            {/each}
          </ul>
        </nav>
      {/each}
    </div>

    <div class="footer__base">
      <p class="footer__copy">© {year} Mountit. All rights reserved.</p>
      <p class="footer__note">
        Mac, macOS, iPadOS, visionOS and Finder are trademarks of Apple Inc.
        Mountit is not affiliated with Apple.
      </p>
    </div>
  </div>
</footer>

<style>
  .footer {
    margin-top: auto;
    padding-block: clamp(2.5rem, 5vw, 4rem) 2rem;
    background: var(--bg-subtle);
    border-top: 1px solid var(--border);
    font-size: 0.9rem;
  }

  .footer__grid {
    display: grid;
    grid-template-columns: minmax(200px, 1.4fr) repeat(4, minmax(120px, 1fr));
    gap: 2.5rem 2rem;
  }

  .footer__blurb {
    margin-top: 0.9rem;
    color: var(--text-muted);
    max-width: 34ch;
    font-size: 0.88rem;
    line-height: 1.6;
  }

  .footer__title {
    font-size: 0.76rem;
    font-weight: 620;
    letter-spacing: 0.08em;
    text-transform: uppercase;
    color: var(--text-faint);
    margin-bottom: 0.85rem;
  }

  .footer__col ul { list-style: none; margin: 0; padding: 0; }
  .footer__col li + li { margin-top: 0.5rem; }
  .footer__col a { color: var(--text-muted); }
  .footer__col a:hover { color: var(--text); }

  .footer__base {
    margin-top: 3rem;
    padding-top: 1.5rem;
    border-top: 1px solid var(--border);
    display: flex;
    flex-wrap: wrap;
    gap: 0.5rem 2rem;
    justify-content: space-between;
    align-items: baseline;
  }
  .footer__copy { margin: 0; color: var(--text-muted); font-size: 0.85rem; }
  .footer__note { margin: 0; color: var(--text-faint); font-size: 0.78rem; max-width: 52ch; }

  @media (max-width: 780px) {
    .footer__grid { grid-template-columns: repeat(2, 1fr); }
    .footer__brand { grid-column: 1 / -1; }
  }
</style>
